<template>
    <div>
        <div v-if="!nav.header">
            <v-list-item
                    :to="nav.to"
                    exact
                    :disabled="isInactive(nav)"
                    v-if="!nav.external"
                    color="white"
                    :class="{submenu: sub}"
            >
                <v-list-item-icon>
                    <v-icon>{{ nav.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ nav.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    :href="nav.link"
                    target="_blank"
                    exact
                    v-if="nav.external"
                    color="white"
                    :class="{submenu: sub}"
            >
                <v-list-item-icon>
                    <v-icon>{{ nav.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ nav.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </div>
        <div v-else>
            <v-list-group
                    no-action
                    sub-group
                    :value="false"
                    color="white"
                    :class="{submenu: sub}"
            >
                <template v-slot:activator>
                    <v-list-item-icon><v-icon>{{nav.icon}}</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{nav.title}}</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item
                        exact
                        v-if="!nav.external"
                        :to="{name: nav.route, params:{team: nav.url}}"
                        v-for="nav in nav.children" :key="nav.title"
                        :class="{subsubmenu: sub}"
                >
                        <v-list-item-title>{{ nav.name}}</v-list-item-title>
                </v-list-item>

            </v-list-group>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NavEntry',
        props: ['nav', 'sub'],
        methods: {
            isInactive (nav) {
                if (!nav.cookies) {
                    return false
                } else {
                    return !this.$store.state.cookies
                }
            }
        }
    }
</script>
<style scoped>
.submenu {
    background:#D84315 !important;
}
    .subsubmenu {
        background: #BF360C !important;
    }
</style>
